import KidsList from "./KidsList"

export default KidsList;